import { AxiosRequestConfig, Method } from 'axios';

import {
    FilterFieldNames, FilterOps, ILeafFilterClause, IStringArrayValuedFieldFilterClause, IStringValuedFieldFilterClause
} from '~src/ts/ServerApi/types/IFilterClause';

import { CollectionError } from '../space/CollectionModels';

export const COLLECTIONS_SERVICE_PATH = 'collections';
export const COLLECTIONS_PATH = `${COLLECTIONS_SERVICE_PATH}/collections`;
export const ITEMS_PATH = `${COLLECTIONS_SERVICE_PATH}/items`;

export interface CollectionsListResponse<T> {
  readonly items?: T[];
  readonly totalCount?: number;
  readonly errors: CollectionError[];
}

export function collectionsAxiosRequestConfig(method: Method, url: string, data?: any): AxiosRequestConfig {
  return {
    method: method,
    url: url,
    data: data,
    headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'}
  };
}

const FilterOpToStringMap = new Map([
  [FilterOps.eq, ':'],
  [FilterOps.gt, '>'],
  [FilterOps.gte, '>='],
  [FilterOps.lt, '<'],
  [FilterOps.lte, '<='],
  [FilterOps.inArray, ':'],
  [FilterOps.has, ':']
]);

export const FilterOpsToString = (op: FilterOps): string => {
  return FilterOpToStringMap.get(op);
};

// Some filter field names are different in Collections and CRASS code so we need to convert them
const MonolithFilterFieldToCollectionsFilterFieldNameMap = new Map([
  [FilterFieldNames.isFavorite, FilterFieldNames.favoriteCollections],
  [FilterFieldNames.contentType, 'type' as const],
  [FilterFieldNames.updatedAt, 'modifiedTime' as const],
  [FilterFieldNames.createdAt, FilterFieldNames.createdTime],
  [FilterFieldNames.isPublished, 'datasourceIsPublished']
]);

export function getCollectionsFilterFieldName(fieldName: string): string {
  return MonolithFilterFieldToCollectionsFilterFieldNameMap.get(fieldName) ?? fieldName;
}

export function getFilterUrlParam(filters: ILeafFilterClause[]) {
return filters
  .filter(clause => clause.operator !== FilterOps.matches)
  .map((clause: IStringValuedFieldFilterClause | IStringArrayValuedFieldFilterClause) => {
    const valueArray = clause.operator === FilterOps.inArray ? clause.values : [clause.value];
    const quotedValues = valueArray.map(v => `"${v}"`).join(',');
    return getCollectionsFilterFieldName(clause.field) + FilterOpsToString(clause.operator) + quotedValues;
  })
  .join(' AND ');
}
